<template>
    <v-toolbar :color="toolbarColor" dark dense elevation="0">
        <v-icon left>mdi-calendar-check</v-icon>
        <v-toolbar-title>System Configuration - Year of Study</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'system-configuration-year-of-study-toolbar',
    computed: {
        toolbarColor() {
            return '#1BC5BD';
        }
    }
}
</script>